module.exports = __webpack_public_path__ + "static/img/3.544e915.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgzgk/3.png
// module id = z469
// module chunks = 0